import Axios from "axios";

export class PlanClienteService {

    lista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/config-cliente/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/matriz/config-cliente/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/matriz/config-cliente/editar`, data).then(res => res.data);
    }

    consultar(id, idp) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/config-cliente/consulta/${id}/${idp}`).then(res => res.data);
    }

    eliminar(id, idp) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/matriz/config-cliente/eliminar/${id}/${idp}`).then(res => res.data);
    }
}
